<div class="container-fluid mt-3" *ngIf="style === tableStyle.Short">
  <div [class]="showLoader ? 'loader show' : 'loader'">
    <!-- loader here -->
  </div>
  <div class="table-title card-header"
       [style.border-bottom-color]="state === 'collapsed' ? '$main-orange' : null">
    <div class=" table-header d-flex">
      <h4 class="table-title">
        <a>
          <i [ngClass]="state === 'collapsed' ? 'fa fa fa-arrow-down' : 'fa fa fa-arrow-up'" (click)="toggle()"></i>
        </a>
          {{tableTitle}}
        </h4>
        <a>
          <i class="fa fa-info-circle fa-sm"></i>
        </a>
    </div>
  </div>
  <div class="table-responsive"
       [@detailExpand]="state">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
           data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort (matSortChange)="sendSortData($event)">
      <thead class="thead-dark">
      <tr>
        <th scope="col"
            mat-sort-header="{{headerDictionary[header]}}"
            *ngFor="let header of headerArray">
            {{headerDictionary[header]}}
        </th>
        <th *ngIf="isWatchlist"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let record of sortedRecords">
        <td *ngFor="let data of headerArray; let i = index">
          {{record[data]}}
        </td>
        <td *ngIf="isWatchlist">
          <i  style="width: 100%; text-align: left; "
            [ngClass]="record['variazione'] >= 0 ? 'fa fa-arrow-up ml-1' : 'fa fa-arrow-down ml-1'"
            [style.color]="record['variazione'] >= 0 ? 'green' : 'red'"></i>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <a class="nav-link" routerLink="{{path}}" routerLinkActive="active">
          <i class="fa fa-plus">
          </i>
          Visualizza tutti
        </a>
      </tr>
      </tfoot>
    </table>
  </div>
</div>

<div class="container-fluid mt-3" *ngIf="style === tableStyle.Extended">
  <div class=" table-header d-flex">
    <h4 class="table-title">
      {{tableTitle}}
    </h4>
    <select class=" table-records-number form-control-sm mr-3" (change)="updateSize($event)">
      <option value="10">Elementi per pagina: 10</option>
      <option value="20">Elementi per pagina: 20</option>
      <option value="30">Elementi per pagina: 30</option>
    </select>
    <a>
      <i class="fa fa-info-circle fa-2x"></i>
    </a>
  </div>
  <div class="table-responsive">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
           data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort (matSortChange)="sendSortData($event)">
      <thead class="thead-dark">
      <tr>
        <th scope="col"
            mat-sort-header="{{headerDictionary[header]}}"
            *ngFor="let header of headerArray">{{headerDictionary[header]}}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let record of sortedRecords">
        <td *ngFor="let data of headerArray">{{record[data]}}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div style="padding-top: 15px">
    <nav>
      <ul class="pagination pagination-circle pg justify-content-center">
        <li class="page-item">
          <a class="page-link" (click)="firstPage()">First</a>
        </li>
        <li  [ngClass]="pageNumber === 1 ? 'page-item disabled' : 'page-item'">
          <a class="page-link"  (click)="previousPage()" title="Previous">
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <li class="page-item active">
          <a class="page-link">{{pageNumber}}</a>
        </li>
        <li class="page-item"  [ngClass]="pageNumber === totalPages ? 'page-item disabled' : 'page-item'" >
          <a class="page-link" (click)="nextPage()" title="Next">
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Next</span>
          </a>
        </li>
        <li class="page-item">
         <a class="page-link" (click)="lastPage()">Last</a>
        </li>
      </ul>
    </nav>
  </div>
</div>

